export default {
    streamNoteListedWebpages:
        'Bitte beachten Sie, dass die aufgelisteten Webseiten kein Eigentum von Netvork LLP sind',
    streamNoteAdministrationCompliance:
        'Ihre Verantwortung und die Einhaltung geltender Gesetze durch ihre Eigentümer liegen nicht in der Verantwortung von Netvork LLP.',
    streamNoteReportEmail:
        'Wenn Sie Probleme mit den Zielseiten haben, melden Sie diese bitte per E-Mail an',
    respectfullyTeam: 'Mit Respekt, das Netvork-Team',
    enterMessengerAccount: 'Geben Sie das Messenger-Konto ein',
    invalidTelegram: 'Ungültige Telegram-Adresse',
    invalidSkype: 'Ungültige Skype/Teams-Adresse',
};
